import React, { useEffect, useState } from "react";
import "../../css_files/Ticket/TicketParts.css";
import CloseForm from "../Master/CloseForm";
import axiosInstance from "../../api";
import Select from "react-select";

function TicketParts({
  newEnquiryData,
  partsTicketLoading,
  partsTicketData,
  collapseparts,
  setcollapseparts,
  extraParts,
  extraPartsInput,
  setExtraPartsInput,
  setPartsTicketLoading,
  setPartsTicketData,
  setShowPartsTicketData,
  setExtraParts,
  setCreatePartsTicket,
  createPartsTicket,
  partnames,
  setpartnames,
}) {
  const [refresh, setrefresh] = useState(false);
  const [searchParts, setsearchParts] = useState("");

  useEffect(() => {
    const fetchParts = async () => {
      if (newEnquiryData?.enquiryType !== "Parts") return;

      setPartsTicketData([]);

      try {
        setPartsTicketLoading(true);
        const partsResponse = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}/api/v1/BoilerPartsMapper/GetAllPartsByBoilersAndSeries?boiler=${newEnquiryData?.customerBoiler?.boilerHead}&series=${newEnquiryData?.customerBoiler?.boilerSeries}&search=${searchParts}`
        );

        const categoryPromises = partsResponse.data?.map((part) =>
          getCategoryById(part.categoryId)
        );

        const categories = await Promise.all(categoryPromises);

        const mergedPartsByCategory = {};

        partsResponse.data?.forEach((part, index) => {
          const category = categories[index];
          if (!mergedPartsByCategory[category])
            mergedPartsByCategory[category] = {
              category,
              parts: [
                { id: part.id, name: part.name, partNumber: part.partNumber },
              ],
            };
          else
            mergedPartsByCategory[category].parts.push({
              id: part.id,
              name: part.name,
              partNumber: part.partNumber,
            });
        });

        setPartsTicketData(Object.values(mergedPartsByCategory));
        setcollapseparts(
          Array.from(
            { length: Object.values(mergedPartsByCategory).length },
            () => true
          )
        );
        setPartsTicketLoading(false);
      } catch (err) {
        console.error(err);
        setPartsTicketLoading(false);
      }
    };

    fetchParts();
  }, [newEnquiryData, refresh]);

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Parts/GetAllPartsDropdown`)
      .then((res) => {
        setpartnames(res.data);
      })
      .catch(console.log);
  }, []);

  function getCategoryById(categoryId) {
    return axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Category/GetCategoryByIdOrName?id=${categoryId}&page=1`
      )
      .then((res) => res.data.data[0].name)
      .catch((err) => "");
  }

  return (
    <section className="ticket-parts">
      <section>
        <h1>Parts Ticket</h1>
        <div className="ticket-parts-div">
          <aside>
            <blockquote>
              <input
                type="checkbox"
                style={{ width: "1.2rem", height: "1.2rem", cursor: "pointer" }}
                title="Select All"
                onChange={(e) => {
                  if (e.target.checked) {
                    setCreatePartsTicket(
                      partsTicketData
                        .map((x) => x.parts.map((y) => y.id))
                        .flat()
                    );
                  } else {
                    setCreatePartsTicket([]);
                  }
                }}
                checked={
                  partsTicketData.map((x) => x.parts.map((y) => y.id)).flat()
                    .length === createPartsTicket.length
                }
              />
              <h2>
                Boiler Model : {newEnquiryData?.customerBoiler?.boiler?.head}
                {", "}
                {newEnquiryData?.customerBoiler?.boilerSeriess?.seriesCode}
              </h2>
              {partsTicketLoading === false && (
                <i
                  className="fa-solid fa-rotate-right"
                  title="Refresh"
                  onClick={() => {
                    setrefresh(!refresh);
                    setsearchParts("");
                  }}
                ></i>
              )}
            </blockquote>
          </aside>
          <aside style={{ flexDirection: "column" }}>
            {partsTicketLoading ? (
              <center style={{ padding: "2rem" }}>
                <i className="fa-solid fa-spinner fa-spin fa-2x"></i>
              </center>
            ) : (
              <div>
                <input
                  type="search"
                  placeholder="Enter Parts (Press Enter Key)"
                  onChange={(e) => {
                    setsearchParts(e.target.value);
                    if (e.target.value?.trim() === "") {
                      setrefresh(!refresh);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setrefresh(!refresh);
                    }
                  }}
                  id="searchPartsinTicketParts"
                  value={searchParts}
                />
                {partsTicketData.length > 0 ? (
                  partsTicketData.map((x, i) => (
                    <>
                      <blockquote
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <h3>
                          {x.category.trim() === ""
                            ? "No Active Category"
                            : x.category}
                        </h3>
                        <i
                          className={`fa-solid ${
                            collapseparts[i] ? "fa-angle-up" : "fa-angle-down"
                          }`}
                          onClick={() => {
                            setcollapseparts((prev) =>
                              prev.map((x, idx) => (idx === i ? !x : x))
                            );
                          }}
                        ></i>
                      </blockquote>
                      {collapseparts[i] && (
                        <blockquote>
                          {x.parts.map((y, index) => (
                            <mark key={index}>
                              <input
                                type="checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setCreatePartsTicket((prev) => [
                                      ...prev,
                                      y.id,
                                    ]);
                                  } else {
                                    setCreatePartsTicket((prev) =>
                                      prev.filter((x) => x !== y.id)
                                    );
                                  }
                                }}
                                checked={createPartsTicket.some(
                                  (x) => x === y.id
                                )}
                              />
                              <p>
                                ({y.partNumber}) {y.name}
                              </p>
                            </mark>
                          ))}
                        </blockquote>
                      )}
                    </>
                  ))
                ) : (
                  <center>
                    <p>No Parts Linked</p>
                  </center>
                )}
              </div>
            )}
            {partsTicketData.length > 0 && (
              <blockquote>
                <mark>
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      setExtraParts(e.target.checked);
                      if (e.target.checked === false) {
                        setExtraPartsInput([]);
                      }
                    }}
                    checked={extraParts}
                  />
                  <p>Extra Parts</p>
                </mark>
                {extraParts && (
                  <Select
                    options={partnames}
                    onChange={(values) => {
                      if (values)
                        setExtraPartsInput(values?.map((x) => x.value));
                    }}
                    value={partnames?.filter((x) =>
                      extraPartsInput?.includes(x.value)
                    )}
                    isClearable
                    isSearchable
                    isMulti
                    placeholder="Select Parts"
                    hideSelectedOptions={false}
                    closeMenuOnSelect={false}
                    menuPlacement="top"
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: "100%",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: "black",
                      }),
                      control: (base, state) => ({
                        ...base,
                        borderColor: "black",
                        "&:hover": {
                          borderColor: "black",
                        },
                        boxShadow: "none",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: "black",
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        color: "black",
                        "&:hover": {
                          color: "black",
                        },
                      }),
                      indicatorSeparator: (base) => ({
                        ...base,
                        backgroundColor: "black",
                      }),
                      noOptionsMessage: (base) => ({
                        ...base,
                        color: "black",
                      }),
                    }}
                  />
                )}
              </blockquote>
            )}
          </aside>
        </div>
        <CloseForm close={setShowPartsTicketData} />
      </section>
    </section>
  );
}

export default TicketParts;
